import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  BrowserRouter,
} from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";
import {} from "./utilities/firebaseConfig";

// Importing all necessary pages
import Homepage from "./pages/homepage/Homepage";
import Login from "./pages/authentication/Login";
import Signup from "./pages/authentication/UserSignup";
import TechnicianDashboard from "./pages/dashboard/TechnicianDashboard";
import TechnicianSignuppage from "./pages/authentication/TechnicianSignupPage";
import TechnicianInfopage from "./pages/authentication/TechncianInfoPage";
import InfopageTwo from "./pages/authentication/TechnicianInfoPageTwo";
import Plan from "./pages/Plan";
import Authselectscreen from "./pages/authentication/authselectscreen";
import PostJob from "./pages/Postjob";
import JobDetails from "./pages/ClientTaskDetailsPage";
import Chat from "./pages/ClientChat";
import Notifications from "./user/Notifications";
import ConfirmJobCompletion from "./user/Confirmjobcompletion";
import UserWallet from "./user/Userwallet";
import TechnicianProfile from "./pages/dashboard/TechnicianProfile";
import ActiveJobs from "./user/Activejob";
import BrowseTechnicians from "./user/Browsetechnicians";
import FavoriteTechnicians from "./user/FavoriteTechnicians";
import SelectTechnician from "./pages/Selecttechnician";
import EditJob from "./user/Editjob";
import ProtectedRoute from "./utilities/ProtectedRoute";
import { AuthProvider } from "./utilities/Auth";
import ServicePricing from "./pages/dashboard/Servicepricing";
import Mytaskpage from "./pages/ClientTasksPage";
import TaskDetails from "./pages/TechncianTaskDetails";
import TechnicianChat from "./pages/TechncianChat";
import TechnicianTasks from "./pages/TechnicianTaskpage";
import ClientDashboard from "./pages/dashboard/ClientDashboard";
import VerifyEmail from "./pages/authentication/ResendVerification";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import JobHistory from "./pages/JobHistory";
import TechnicianJobHistory from "./pages/TechnicianJobHistory";
import TechnicianWallet from "./technician/TechnicianWallet";

const googleMapsApiKey = "AIzaSyCq1eeQipLUK-43-lJPCGWIZAVzJuuhWpY";

// ✅ Handles authentication and redirection
// function AuthHandler() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [user, setUser] = useState(null);
//   const [role, setRole] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     requestNotificationPermission();
//   }, []);

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
//       if (authUser) {
//         setLoading(true);

//         const [userSnapshot, technicianSnapshot] = await Promise.all([
//           get(ref(db, `users/${authUser.uid}`)),
//           get(ref(db, `technicians/${authUser.uid}`)),
//         ]);

//         if (userSnapshot.exists()) {
//           setUser(authUser);
//           setRole("user");
//           if (["/login", "/client/signup", "/selection_auth"].includes(location.pathname)) {
//             navigate("/client/dashboard", { replace: true });
//           }
//         } else if (technicianSnapshot.exists()) {
//           const technicianData = technicianSnapshot.val();
//           setUser(authUser);
//           setRole("technician");

//           let nextRoute = "/technician/dashboard";
//           if (!technicianData.step1Completed) nextRoute = "/technician/signup";
//           else if (!technicianData.step2Completed) nextRoute = "/technician/info";
//           else if (!technicianData.step4Completed) nextRoute = "/technician/info_two";

//           if (location.pathname !== nextRoute) {
//             navigate(nextRoute, { replace: true });
//           }
//         } else {
//           setUser(null);
//           setRole(null);
//         }
//       } else {
//         setUser(null);
//         setRole(null);
//       }

//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, [navigate, location.pathname]);

//   if (loading) return <Loader />;

//   return null;
// }

// ✅ App Routes with smooth transitions
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path='/' element={<Homepage />} />
          <Route path='/login' element={<Login />} />
          <Route path='/selection_auth' element={<Authselectscreen />} />

          {/* User Sign Up */}
          <Route path='/client/signup' element={<Signup />} />
          <Route path='/client/plan' element={<Plan />} />
          <Route path='/client/my_task' element={<Mytaskpage />} />

          <Route element={<ProtectedRoute allowedRoles={["user"]} />}>
            <Route path='/client/dashboard' element={<ClientDashboard />} />
            <Route
              path='/client/post-job'
              element={
                <LoadScript
                  googleMapsApiKey={googleMapsApiKey}
                  libraries={["places"]}
                >
                  <PostJob />
                </LoadScript>
              }
            />
          </Route>

          {/* User Dashboard */}

          {/* Technician Routes */}
          <Route path='/technician/signup' element={<TechnicianSignuppage />} />
          <Route path='/technician/info' element={<TechnicianInfopage />} />
          <Route path='/technician/info_two' element={<InfopageTwo />} />
          <Route
            path='/technician/job-history'
            element={<TechnicianJobHistory />}
          />

          <Route element={<ProtectedRoute allowedRoles={["technician"]} />}>
            <Route
              path='/technician/dashboard'
              element={<TechnicianDashboard />}
            />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["technician"]} />}>
            <Route path='/technician/profile' element={<TechnicianProfile />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={["technician"]} />}>
            <Route
              path='/technician/service_pricing'
              element={<ServicePricing />}
            />
          </Route>
          <Route
            path='/technician/task_details/:taskId'
            element={<TaskDetails />}
          />

          {/* Job Posting & Selection */}
          <Route path='/edit-job/:jobId' element={<EditJob />} />
          <Route
            path='/select-technician/:jobId'
            element={<SelectTechnician />}
          />
          <Route path='/browse-technicians' element={<BrowseTechnicians />} />
          <Route path='/favorites' element={<FavoriteTechnicians />} />

          {/* Job Details & Actions */}
          <Route path='/client/job/:jobId' element={<JobDetails />} />
          <Route path='/client/chat/:jobId' element={<Chat />} />
          <Route path='/client/job-history' element={<JobHistory />} />
          <Route path='/technician/task' element={<TechnicianTasks />} />
          <Route path='/technician/wallet' element={<TechnicianWallet />} />
          <Route path='/technician/chat/:taskId' element={<TechnicianChat />} />
          <Route path='/notifications' element={<Notifications />} />
          <Route
            path='/confirm-job/:jobId'
            element={<ConfirmJobCompletion />}
          />

          {/* Wallet & Profile */}
          <Route path='/wallet' element={<UserWallet />} />
          {/* <Route
            path='/technician-profile/:techId'
            element={<TechnicianProfile />}
          /> */}
          <Route path='/active-jobs' element={<ActiveJobs />} />
          <Route path='/verify-email' element={<VerifyEmail />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          {/* Catch all unknown routes */}
          <Route path='*' element={<Navigate to='/login' replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
